import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export interface AIAnnotationWatchmenPluginState {
	isWatching: boolean;
	startingAnnotationIds?: string[];
	watchFrom?: number;
	watchTo?: number;
}

export const aiAnnotationWatchmenPluginKey = new PluginKey<AIAnnotationWatchmenPluginState>(
	'aiAnnotationWatchmen',
);
